import {
  FormSection,
  GridContainer,
  GridItem,
  AlertSpg,
  ScrollableAsyncFormAutocomplete,
  AsyncCallArgs,
  useAsyncCall,
} from "@duosoftbg/nacid-components";
import { useTranslation } from "react-i18next";
import { autocompleteRelatedRecognitions, getUniversitiesRecognition } from "../../../../../../../axios/api/services";
import { useWatch } from "react-hook-form";
import { useEffect, useState } from "react";

const RequestRelatedRecognitionSection = () => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();
  const [selected, setSelected] = useState(null);

  const relatedRecognitionId = useWatch({ name: "relatedRecognitionId" });

  useEffect(() => {
    if (relatedRecognitionId && relatedRecognitionId !== "") {
      const asyncGet: AsyncCallArgs = {
        withGlobalBackdrop: false,
        promise: getUniversitiesRecognition(relatedRecognitionId),
        onSuccess: (response) => {
          setSelected({
            id: response.id,
            name: `${response.protocolNumber ? response.protocolNumber + " - " : ""}${response.applicant}`,
          });
        },
      };
      asyncCall(asyncGet);
    } else {
      setSelected(null);
    }
  }, [relatedRecognitionId]);

  return (
    <FormSection label={"t.arUniEntryRequest.relatedRecognition.details"}>
      <GridContainer spacing={4} mt={0}>
        <GridItem sm={12} md={12}>
          <AlertSpg severity={"info"}>{t("m.arUniEntryRequest.relatedRecognition.info")}</AlertSpg>
        </GridItem>
        <GridItem sm={12} md={12}>
          <ScrollableAsyncFormAutocomplete
            fieldName={"relatedRecognitionId"}
            label={"l.arUniEntryRequest.relatedRecognitionId"}
            autocompleteFn={autocompleteRelatedRecognitions}
            setOptionText={(option) => `${option.name}`}
            setInputOnSelect={(option) => `${option.name}`}
            getOptionLabel={(option) => option.id + ""}
            selectedOption={selected}
            inputMinSearchLength={0}
          />
        </GridItem>
      </GridContainer>
    </FormSection>
  );
};
export default RequestRelatedRecognitionSection;
